import {
  HHLink,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { routes } from '../../../constants/strings/routes';
import { capitalizeFirstLetterAndSpaceSnakeString } from '../../../utils/bills-utils';

export interface AggregateHoldTypeCellProps {
  holdTypes: string;
}

export const AggregateHoldTypeCell = ({
  holdTypes,
}: AggregateHoldTypeCellProps): JSX.Element => {
  const holdTypesList = holdTypes
    .split(',')
    .map(type => type.trim())
    .filter(type => type.length > 0)
    .map(type => capitalizeFirstLetterAndSpaceSnakeString(type));

  return (
    <HHStack direction="column" gap={0.5}>
      {holdTypesList.map(type => (
        <HHTypography key={type} hhVariant="body2">
          {type}
        </HHTypography>
      ))}
    </HHStack>
  );
};

export interface AggregateClientCellProps {
  client: { id: number; name: string };
}

export const AggregateClientCell = ({
  client,
}: AggregateClientCellProps): JSX.Element => (
  <HHStack>
    <HHLink
      color="primary"
      href={`${routes.billing.home}/${routes.billing.clientPath}/${client.id}`}
      target="_blank"
      sx={{ textDecoration: 'none' }}
    >
      {client.name}
    </HHLink>
  </HHStack>
);
